import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { LayoutModule } from "@angular/cdk/layout";
import { EducationComponent } from "./education/education.component";
import { JumbotronComponent } from "./jumbotron/jumbotron.component";
import { WorkComponent } from "./work/work.component";
import { SharedCardGridComponent } from "./shared-card-grid/shared-card-grid.component";
import { AboutComponent } from "./about/about.component";
import { DisclaimerComponent } from "./disclaimer/disclaimer.component";
import { ContactComponent } from "./contact/contact.component";
import { NgParticlesModule } from "ng-particles";

@NgModule({
  declarations: [
    AppComponent,
    EducationComponent,
    JumbotronComponent,
    WorkComponent,
    SharedCardGridComponent,
    AboutComponent,
    DisclaimerComponent,
    ContactComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    NgParticlesModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
